function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "19.319"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2146",
  "data-name": "Rectangle 2146",
  fill: "none",
  d: "M0 0h25v19.319H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4986",
  "data-name": "Group 4986"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4985",
  "data-name": "Group 4985",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2793",
  "data-name": "Path 2793",
  d: "M23.709 4.618l-4.557 4.557-.944-.944-.943-.944 6-6L21.969 0l-6 6-1.287 1.287-2.1 2.1a3.111 3.111 0 00-1.074.126 3.077 3.077 0 00-2.078 2.451 29.579 29.579 0 01-1.883 5.528H0v1.827h8.371v-.043a1.2 1.2 0 00.248.03h.069c1.246-.068 4.363-.442 6.363-2.442a5.724 5.724 0 001.849-2.858l2.248-2.248 1.292-1.292L25 5.91zm-9.95 10.953a7.5 7.5 0 01-4.178 1.81 28.6 28.6 0 001.643-5.071 1.251 1.251 0 01.818-1.048 1.234 1.234 0 01.367-.053 2.943 2.943 0 011.921 1.005c1.256 1.256 1 1.79-.571 3.357m2.754-3.757l-1.887-1.888 1.347-1.347.944.943.944.944z",
  fill: "#fff"
})))));